import { render } from "./ConnectedProfileItem.vue?vue&type=template&id=03c690aa"
import script from "./ConnectedProfileItem.vue?vue&type=script&lang=js"
export * from "./ConnectedProfileItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/ConnectedProfileItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03c690aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03c690aa', __exports__)) {
    api.reload('03c690aa', __exports__)
  }
  
  module.hot.accept("./ConnectedProfileItem.vue?vue&type=template&id=03c690aa", () => {
    api.rerender('03c690aa', render)
  })

}


export default __exports__